<template>
  <div class="chats">
    <div
      class="chat"
      :class="{ 'chat-left': chatData.mUser != $route.params.id }"
    >
      <div class="chat-body">
        <div
          class="chat-content position-relative"
          :class="{ 'pb-2': chatData.mUser != $route.params.id }"
        >
          <p class="single-message">{{ chatData.messageBody }}</p>

          <p>{{ timeAgo(chatData.createDate) }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api";
import { BAvatar } from "bootstrap-vue";
import DoubleCheckIcon from "@/views/components/icons/DoubleCheckIcon";
// import { mapGetters } from "vuex";

export default {
  components: {
    DoubleCheckIcon,
    BAvatar,
  },
  props: {
    chatData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    // ...mapGetters(["SocketId"]),
  },
  mounted() {
    // console.log(this.chatData.userInfo.userId)
  },
  setup(props) {
    const formattedChatData = computed(() => {
      const contact = {
        id: props.chatData.mUser,
        avatar: `https://api.faradidar.com/${props.user.selfieFileData}`,
      };

      let chatLog = [];
      if (props.chatData.chat) {
        chatLog = props.chatData.chat.chat;
      }

      const formattedChatLog = [];
      let chatMessageSenderId = chatLog[0] ? chatLog[0].mUser : undefined;
      let msgGroup = {
        sender: chatMessageSenderId,
        messages: [],
      };

      chatLog.forEach((msg, index) => {
        if (chatMessageSenderId === msg.mUser) {
          msgGroup.messages.push({
            msg: msg.message,
            time: msg.time,
          });
        } else {
          chatMessageSenderId = msg.mUser;
          formattedChatLog.push(msgGroup);
          msgGroup = {
            senderId: msg.mUser,
            messages: [
              {
                msg: msg.message,
                time: msg.time,
              },
            ],
          };
        }
        if (index === chatLog.length - 1) formattedChatLog.push(msgGroup);
      });

      return {
        formattedChatLog,
        contact,
      };
    });

    return {
      formattedChatData,
    };
  },
  methods: {
    openAttachedFile(fileData) {
      window.open(`https://api.faradidar.com/${fileData}`);
    },
    timeAgo(time) {
      switch (typeof time) {
        case "number":
          break;
        case "string":
          time = +new Date(time);
          break;
        case "object":
          if (time.constructor === Date) time = time.getTime();
          break;
        default:
          time = +new Date();
      }
      let time_formats = [
        [60, "ثانیه ", 1], // 60
        [120, "1 دقیقه پیش", "یک دقیقه از الان"], // 60*2
        [3600, "دقیقه ", 60], // 60*60, 60
        [7200, "1 ساعت پیش", "1 ساعت از الان"], // 60*60*2
        [86400, "ساعت ", 3600], // 60*60*24, 60*60
        [172800, "دیروز", "فردا"], // 60*60*24*2
        [604800, "روز ", 86400], // 60*60*24*7, 60*60*24
        [1209600, "هفته پیش", "هفته بعد"], // 60*60*24*7*4*2
        [2419200, "هفته", 604800], // 60*60*24*7*4, 60*60*24*7
        [4838400, "ماه پیش", "ماه بعد"], // 60*60*24*7*4*2
        [29030400, "ماه", 2419200], // 60*60*24*7*4*12, 60*60*24*7*4
        [58060800, "سال پیش", "سال بعد"], // 60*60*24*7*4*12*2
        [2903040000, "سال", 29030400], // 60*60*24*7*4*12*100, 60*60*24*7*4*12
      ];
      let seconds = (+new Date() - time) / 1000,
        token = "پیش",
        list_choice = 1;

      if (seconds == 0) {
        return "همین حالا";
      }
      if (seconds < 0) {
        seconds = Math.abs(seconds);
        token = "از الان";
        list_choice = 2;
      }
      let i = 0,
        format;
      while ((format = time_formats[i++]))
        if (seconds < format[0]) {
          if (typeof format[2] == "string") return format[list_choice];
          else
            return (
              Math.floor(seconds / format[2]) + " " + format[1] + " " + token
            );
        }
      return time;
    },
  },
};
</script>

<style scoped>
.ticket-img {
  width: 10rem;
  height: 10rem;
  margin-top: 10px;
  background-size: contain;
  background-repeat: no-repeat;
}
.single-message {
  white-space: normal !important;
  overflow-wrap: anywhere;
}
.deliver {
  position: absolute;
  bottom: 5px;
  right: 5px;
}
</style>
